import React from "react";
import "./SupplyOfConstruction.css";

const SupplyOfConstruction = () => {
  return (
    <div>
      <h1>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Voluptas, et!
      </h1>
    </div>
  );
};

export default SupplyOfConstruction;
